export const tourGuideSteps = [
  {
    selector: "#support-event-detail-header",
    content:
      "On the System Event Detail page users can see a summary of the event including the full contents of the label.",
  },
  {
    selector: "#update-event-button",
    content:
      "Click this button to add a comment to the event without resolving it.",
  },
  {
    selector: "#resolve-event-button",
    content:
      "Click this button to resolve the event with a comment.",
  },
  {
    selector: "#support-event-detail-data-grid",
    content:
      "This grid displays all comments and notes related to this event.",
  },
];
